import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import {
  shouldShowGearModePlayer,
  isBroadcastStreaming,
  // @ts-expect-error — importing js
} from '../../../selectors'
// @ts-expect-error — importing js
import { PlaybackVideoControlsBarComponent } from '../..'

// @ts-expect-error — importing js
import SecondaryBar from './SecondaryBar'
// @ts-expect-error — importing js
import Header from './Header'
// @ts-expect-error — importing js
import Toolbar from './Toolbar'
// @ts-expect-error — importing js
import Overlay from './Overlay'
// @ts-expect-error — importing js
import SecondCameraModal from './SecondCameraModal'
import GearMode from './GearMode'
import { ParticipantStrip } from '../../../../ParticipantStrip/components/ParticipantStrip/ParticipantStrip'
import StageContainer from '../../stage-container/stage-container'
import { HeadsUpDisplay } from '../../HeadsUpDisplay'
import { useLocalParticipant } from '../../../../webrtc/webRTCRoom'
import { ParticipantsAudio } from '../../../../MediaTracks/components/ParticipantsAudio/ParticipantsAudio'
import { VideoPlaybackAudioTrack } from '../../../../MediaTracks/components/VideoPlaybackAudioTrack/VideoPlaybackAudioTrack'
import useFeatures from '../../../../sharedLegacy/hooks/useFeatures'
import { Transcriptions } from '../../../../Stage/floor/Transcriptions/Transcriptions'
import { useFloorState } from '../../../../firebase/hooks/useFloor'
import { usePanelScreen } from '../../../../firebase/hooks/usePanel'
import { useLastActiveMediaTrayCard } from '../../../../firebase/hooks/useTray'

interface WebinarRoomContentProps {
  /** Connected properties */
  isProducer: boolean
  isPresenter: boolean
  isGuest: boolean
  isVideoPlaying: boolean
  isInGearMode: boolean
  showGearModePlayer: boolean
  liveData: unknown
  webinarEnded: boolean
  isEndingWebinar: boolean
  isStreaming: boolean
}

const WebinarRoomContent = ({
  isProducer,
  isPresenter,
  isGuest,
  isVideoPlaying,
  isInGearMode,
  showGearModePlayer,
  liveData,
  webinarEnded,
  isEndingWebinar,
  isStreaming,
}: WebinarRoomContentProps) => {
  const isProducing = isProducer && !webinarEnded && !isEndingWebinar

  const localParticipant = useLocalParticipant()
  const floor = useFloorState()
  const lastActiveMediaTrayCard = useLastActiveMediaTrayCard()

  const panelScreenState = usePanelScreen()

  const { HasPanelMixedModeEnabled } = useFeatures()

  const isLocalParticipantLive =
    floor?.layout === 'solo' &&
    floor?.participantId === localParticipant?.id &&
    floor?.identifier === 'camera'

  return (
    <div className="webinar-content">
      <Header>
        {!isGuest && (
          <div className="top-corner-info-tools">
            <SecondaryBar />
            <Toolbar />
          </div>
        )}
      </Header>

      {isInGearMode ? (
        <div className="webinar-preview">
          {isProducing && (
            <GearMode
              showGearModePlayer={showGearModePlayer}
              isStreaming={isStreaming}
              liveData={liveData}
            />
          )}
        </div>
      ) : (
        <>
          <div
            className={classnames('webinar-preview', {
              'webinar-presenter-preview': isPresenter,
              'webinar-guest-presenter-preview': isGuest,
            })}
            data-live={isLocalParticipantLive}
          >
            {isProducing &&
              isVideoPlaying &&
              lastActiveMediaTrayCard?.type === 'video' &&
              (floor?.layout === 'tray' ||
                (HasPanelMixedModeEnabled &&
                  floor?.layout === 'panel' &&
                  panelScreenState === 'tray')) && (
                <PlaybackVideoControlsBarComponent />
              )}
            <StageContainer />
          </div>
          <div className="hud-wrapper">
            <HeadsUpDisplay />
          </div>
          <Transcriptions />
          <ParticipantStrip />
          <SecondCameraModal />
          <ParticipantsAudio />
          <VideoPlaybackAudioTrack />
        </>
      )}
      <Overlay />
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  /**
   * Connected properties
   */
  isVideoPlaying: state.webinarPlayback.isVideoPlaying,
  isInGearMode: state.webinar.isGearMode,
  showGearModePlayer: shouldShowGearModePlayer(state),
  liveData: state.webinar.liveData,
  webinarEnded: state.webinar.webinarEnded,
  isEndingWebinar: state.webinar.isEndingWebinar,
  isStreaming: isBroadcastStreaming(state),
})

export default connect(mapStateToProps)(WebinarRoomContent)
